"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deployments = void 0;
/**
 * Represents the known deployments of the ERC1056 registry contract.
 */
exports.deployments = [
    { chainId: 1, registry: '0xdca7ef03e98e0dc2b855be647c39abe984fcf21b', name: 'mainnet', legacyNonce: true },
    // { chainId: 3, registry: '0xdca7ef03e98e0dc2b855be647c39abe984fcf21b', name: 'ropsten', legacyNonce: true },
    // { chainId: 4, registry: '0xdca7ef03e98e0dc2b855be647c39abe984fcf21b', name: 'rinkeby', legacyNonce: true },
    { chainId: 5, registry: '0xdca7ef03e98e0dc2b855be647c39abe984fcf21b', name: 'goerli', legacyNonce: true },
    { chainId: 11155111, registry: '0x03d5003bf0e79C5F5223588F347ebA39AfbC3818', name: 'sepolia', legacyNonce: false },
    // { chainId: 42, registry: '0xdca7ef03e98e0dc2b855be647c39abe984fcf21b', name: 'kovan', legacyNonce: true },
    // // rsk networks cause socket hang up
    // { chainId: 30, registry: '0xdca7ef03e98e0dc2b855be647c39abe984fcf21b', name: 'rsk', legacyNonce: true },
    // {
    //   chainId: 31,
    //   registry: '0xdca7ef03e98e0dc2b855be647c39abe984fcf21b',
    //   name: 'rsk:testnet',
    //   legacyNonce: true,
    // },
    {
        chainId: 246,
        registry: '0xE29672f34e92b56C9169f9D485fFc8b9A136BCE4',
        name: 'ewc',
        description: 'energy web chain',
        legacyNonce: false,
    },
    {
        chainId: 73799,
        registry: '0xC15D5A57A8Eb0e1dCBE5D88B8f9a82017e5Cc4AF',
        name: 'volta',
        description: 'energy web testnet',
        legacyNonce: false,
    },
    {
        chainId: 246785,
        registry: '0xdCa7EF03e98e0DC2B855bE647C39ABe984fcF21B',
        name: 'artis:tau1',
        legacyNonce: true,
    },
    {
        chainId: 246529,
        registry: '0xdCa7EF03e98e0DC2B855bE647C39ABe984fcF21B',
        name: 'artis:sigma1',
        legacyNonce: true,
    },
    { chainId: 137, registry: '0xdca7ef03e98e0dc2b855be647c39abe984fcf21b', name: 'polygon', legacyNonce: true },
    {
        chainId: 80001,
        registry: '0xdca7ef03e98e0dc2b855be647c39abe984fcf21b',
        name: 'polygon:test',
        legacyNonce: true,
    },
    {
        chainId: 1313161554,
        registry: '0x63eD58B671EeD12Bc1652845ba5b2CDfBff198e0',
        name: 'aurora',
        legacyNonce: true,
    },
    {
        chainId: 59140,
        registry: '0x03d5003bf0e79C5F5223588F347ebA39AfbC3818',
        name: 'linea:goerli',
        legacyNonce: false,
    },
];
//# sourceMappingURL=deployments.js.map